module.exports = __webpack_public_path__ + "img/slow_brand_logo.f481d9f1.png";